module.exports = __webpack_public_path__ + "img/logo-sm.2a051f37.png";